import UserAxios from '../Assets/Axios/Axios';

const verifyOTP = async ({ referenceID, OTP }) => {
  const response = await UserAxios({
    query: `mutation VerifyMobileCode($referenceId: String!, $code: String!) {
      verifyCode(data: { referenceId: $referenceId, code: $code }) {
        status
        isValid
      }
    }`,
    variables: {
      referenceId: referenceID,
      code: OTP,
    },
  });

  if (response?.errors) {
    throw new Error(response.errors[0]?.message || 'Failed to verify OTP');
  }

  const result = response?.data?.verifyCode;
  return {
    data: {
      ...result,
      description: result?.isValid ? 'verification success' : 'verification failed',
    },
  };
};

export default verifyOTP;
